import { axiosInstance } from "../client";
import { ReplacementTransportOption } from "@rumble-it/common-lib/types/models/ReplacementTransportOption.interface.ts";
import { ReplacementTransportPlan } from "@rumble-it/common-lib/types/models/ReplacementTransportPlan.interface.ts";
import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";
import { MIME_TYPE_MERGE_PATCH_JSON } from "@rumble-it/common-lib/src/constants/mimeTypes";
import { ReplacementTransportPlanInputDto } from "../../../pages/admin/replacement-transports/plans/components/ReplacementTransportPlanFormCard";
import { ReplacementTransportOptionInputDto } from "../../../pages/admin/replacement-transports/options/components/ReplacementTransportOptionFormCard";
import { PaginationParams } from "@rumble-it/common-lib/types/api/PaginationParams.interface";

interface ReplacementTransportPlanParams {
  dossierType: string;
  company: string;
}

export const fetchReplacementTransportOptions = async (): Promise<
  CollectionResponse<ReplacementTransportOption>
> =>
  axiosInstance
    .get(`/admin/replacement-transport/options`)
    .then((response) => response.data);

export const fetchReplacementTransportOptionById = async (
  id: string,
): Promise<ReplacementTransportOption> =>
  axiosInstance
    .get(`/admin/replacement-transport/options/${id}`)
    .then((response) => response.data);

export const createReplacementTransportOption = async (
  data: ReplacementTransportOptionInputDto,
): Promise<ReplacementTransportOption> =>
  axiosInstance
    .post(`/admin/replacement-transport/options`, data)
    .then((response) => response.data);

export const updateReplacementTransportOptionById = async (
  id: string,
  data: ReplacementTransportOptionInputDto,
): Promise<null> =>
  axiosInstance
    .patch(`/admin/replacement-transport/options/${id}`, data, {
      headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
    })
    .then((response) => response.data);

export const deleteReplacementTransportOptionById = async (
  id: string,
): Promise<null> =>
  axiosInstance
    .delete(`/admin/replacement-transport/options/${id}`)
    .then((response) => response.data);

export const fetchReplacementTransportPlans = async (
  params: PaginationParams,
): Promise<CollectionResponse<ReplacementTransportPlan>> =>
  axiosInstance
    .get(`/admin/replacement-transport/plans`, { params })
    .then((response) => response.data);

export const fetchReplacementTransportPlanById = async (
  id: string,
): Promise<ReplacementTransportPlan> =>
  axiosInstance
    .get(`/admin/replacement-transport/plans/${id}`)
    .then((response) => response.data);

export const createReplacementTransportPlan = async (
  data: ReplacementTransportPlanInputDto,
): Promise<ReplacementTransportPlan> =>
  axiosInstance
    .post(`/admin/replacement-transport/plans`, data)
    .then((response) => response.data);

export const updateReplacementTransportPlanById = async (
  id: string,
  data: ReplacementTransportPlanInputDto,
): Promise<null> =>
  axiosInstance
    .patch(`/admin/replacement-transport/plans/${id}`, data, {
      headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
    })
    .then((response) => response.data);

export const deleteReplacementTransportPlanById = async (
  id: string,
): Promise<null> =>
  axiosInstance
    .delete(`/admin/replacement-transport/plans/${id}`)
    .then((response) => response.data);

export const fetchReplacementTransportPlansByCompanyId = async (
  params: ReplacementTransportPlanParams,
): Promise<ReplacementTransportPlan> =>
  axiosInstance
    .get(`/driver/replacement-transport/plans`, { params })
    .then((response) => response.data);

export const mapReplacementTransportPlansToSelectOptions = (
  plans: ReplacementTransportPlan,
): { label: string; value: string }[] =>
  plans?.options?.member?.map((option) => ({
    label: option.option.title,
    value: option.option.title,
  })) ?? [];
